import { createApp } from 'vue';
import App from './app.vue'

import 'leaflet/dist/leaflet.css';

import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/reset.css';

import statusOf from '@/status'
import scheduleOf from '@/schedule'

import { router } from './router';

const app = createApp(App)

app.mixin({
  methods: {
    statusOf,
    scheduleOf,
  },
})

app
.use(Antd)
.use(router)
.mount('#app')
